import React, { useContext } from 'react';
import classNames from 'classnames';
import useListerApi from '../../../listerApiHooks';
import ResetIcon from '../../../../../../../svg/icons/rolex/rolex-arrow-circle.svg';
import { MessagePropertiesContext } from '../../../../../contexts/messageProperties';
import styles from './resetButton.module.pcss';
import ScrollToElement from '../../../../../helpers/scrollToElement';

interface ResetFiltersButtonProps {
  isDisabled: boolean;
}

export function ResetFiltersButtonLG({ isDisabled }: ResetFiltersButtonProps): React.ReactElement {
  const [formattedMessage] = useContext(MessagePropertiesContext);
  const { selectFacet } = useListerApi();

  const resetFacetsHandler = (): void => {
    selectFacet();
    ScrollToElement('listerRoot');
  };

  return (
    <button
      type="button"
      disabled={isDisabled}
      onClick={resetFacetsHandler}
      className={classNames(styles['reset-filters'], 'rolex-button rolex-button--filled hide-global-rolex-up-to-lg')}
    >
      <ResetIcon />
      <span>{formattedMessage({ id: 'rolex.plp.resetButton', fallback: 'Reset filters' })}</span>
    </button>
  );
}

export function ResetFiltersButtonSM({ isDisabled }: ResetFiltersButtonProps): React.ReactElement {
  const [formattedMessage] = useContext(MessagePropertiesContext);
  const { selectFacet } = useListerApi();

  const resetFacetsHandler = (): void => {
    selectFacet();
    ScrollToElement('listerRoot');
  };

  return (
    <button
      type="button"
      disabled={isDisabled}
      onClick={resetFacetsHandler}
      className="rolex-button rolex-button--icon-only hide-global-rolex-lg-up"
      aria-label={formattedMessage({ id: 'rolex.plp.resetButton', fallback: 'Reset filters' })}
    >
      <ResetIcon className="icon" />
    </button>
  );
}
